/** Max selected provider IDs sent as tool arguments (`get_provider_volume` limit). */
export const SCOUT_MAX_PROVIDER_IDS = 50;

/** Decimal places map bounds are rounded to (~1 km), so Scout sees stable values. */
export const MAP_COORD_DECIMALS = 2;

/** What the heatmap shows when it's on with no metric picked (HeatmapControls). */
export const HEATMAP_ALL_OPPORTUNITIES = 'All Opportunities';
